// extracted by mini-css-extract-plugin
export default {"container":"info_container__cwrAN","box":"info_box__y7O8Q","heading":"info_heading__aWjSL","text":"info_text__Hs58o"};